const { WELCOME_PAGE_MANAGEMENT: Types } = require('../action-types');
const { combineReducers } = require('redux');

const status = (state = 'idle', action) => {

    switch (action.type) {
        case Types.FETCH_SETTINGS.REQUEST:
            return 'loading';
        case Types.FETCH_SETTINGS.SUCCESS:
            return 'loaded';
        case Types.FETCH_SETTINGS.FAILURE:
            return 'error';
        default:
            return state;
    }
};

const settings = (state = null, action) => {

    switch (action.type) {
        case Types.FETCH_SETTINGS.SUCCESS:
            return action.payload?.result || null;

        case Types.UPDATE_SCHOOL_TEXT.SUCCESS: {

            if (!state || !action.payload?.result) {
                return state;
            }

            return {
                ...state,
                homeText: action.payload.result.homeText,
                roleHomeTextEnabled: action.payload.result.roleHomeTextEnabled ?? true
            };
        }

        case Types.UPDATE_ROLE_TEXT.SUCCESS: {

            const updatedRole = action.payload?.result;

            if (!state || !updatedRole) {
                return state;
            }

            return {
                ...state,
                roles: (state.roles || []).map((role) => (
                    role.id === updatedRole.roleId
                        ? { ...role, homeText: updatedRole.homeText }
                        : role
                ))
            };
        }

        default:
            return state;
    }
};

const reducer = combineReducers({
    status,
    settings
});

const selectors = {
    getWelcomePageManagementStatus: (state) => state.status,
    getWelcomePageManagementSettings: (state) => state.settings
};

module.exports = Object.assign(reducer, { selectors });
